import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';

import QuizAdmin from './quizzes/QuizAdmin.jsx';
import FanPollAdmin from './fan-polls/FanPollAdmin.jsx';
import WeeklyQuizzes from './weekly-quizzes/WeeklyQuizzes.jsx';
import SocialHub from './social-hub/SocialHub.jsx';
import UserAdmin from './users/UserAdmin.jsx';
import quizmydayLogo from "./quizmyday-logo.png";

/**
 * Generic TabPanel that keeps content mounted
 */
function TabPanel({ children, value, index }) {
    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            sx={{ height: '100%' }}
        >
            {children}
        </Box>
    );
}

function MainEditor() {
    const [tabIndex, setTabIndex] = useState(0);

    const handleTabChange = (event, newTabIndex) => {
        setTabIndex(newTabIndex);
    };

    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* Header */}
            <Box
                sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                <Box sx={{ height: '50px', mr: '30px' }}>
                    <img
                        alt="quizmyday"
                        src={quizmydayLogo}
                        height={50}
                    />
                </Box>

                <Tabs value={tabIndex} onChange={handleTabChange}>
                    <Tab label="Quizzes" />
                    <Tab label="Fan Polls" />
                    <Tab label="Weekly Quizzes" />
                    <Tab label="Social Hub" />
                    <Tab label="User Management" />
                </Tabs>
            </Box>

            {/* Panels (ALL MOUNTED) */}
            <Box sx={{ flexGrow: 1 }}>
                <TabPanel value={tabIndex} index={0}>
                    <QuizAdmin />
                </TabPanel>



                <TabPanel value={tabIndex} index={1}>
                    <FanPollAdmin />
                </TabPanel>

                <TabPanel value={tabIndex} index={2}>
                    <WeeklyQuizzes />
                </TabPanel>

                <TabPanel value={tabIndex} index={3}>
                    <SocialHub />
                </TabPanel>

                <TabPanel value={tabIndex} index={4}>
                    <UserAdmin />
                </TabPanel>
            </Box>
        </Box>
    );
}

export default MainEditor;
